import {GOLD_300} from '@wandb/weave/common/css/globals.styles';
import {regexMatchHighlight} from '@wandb/weave/common/util/fuzzyMatch';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, IconNames} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'Pill' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Pill} from '@wandb/weave/components/Tag';
import {Tailwind} from '@wandb/weave/components/Tailwind';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import {maybePluralizeWord} from '@wandb/weave/core/util/string';
import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';

import {capitalizeFirstLetter} from '../../../util/string';
import * as urls from '../../../util/urls';
import {formatNumber} from '../../util/formatNumber';
import {RegistriesSearchContext} from '../common/RegistriesSearchContextProvider';
import {globalRegistryType} from '../common/utils';

export const CARD_HEIGHT = '142px';
export const CARD_MIN_WIDTH = '272px';

export const DefaultRegistryCard = (props: globalRegistryType) => {
  const history = useHistory();
  const {
    orgName,
    registryName,
    description,
    types,
    collectionCount,
    allowAllArtifactTypesInRegistry,
  } = props;
  const {searchFilterRegex} = useContext(RegistriesSearchContext);
  return (
    <Tailwind style={{height: CARD_HEIGHT, minWidth: CARD_MIN_WIDTH}}>
      <div
        data-test={`registry-${registryName}`}
        className="flex h-full w-full cursor-pointer flex-col items-start gap-12 rounded border border-moon-200 bg-white p-16 hover:border-teal-350"
        onClick={() => {
          history.push(urls.globalRegistry(orgName, registryName));
        }}>
        <div className="flex h-full w-full flex-row items-center justify-between">
          <div className="flex w-full flex-col items-start gap-4">
            <div className="flex w-full items-center text-xl leading-6 text-moon-800">
              {searchFilterRegex
                ? regexMatchHighlight(registryName, searchFilterRegex, {
                    backgroundColor: GOLD_300,
                  })
                : capitalizeFirstLetter(registryName)}
            </div>

            <div className="text-sm font-normal leading-5 text-moon-500">
              {description}
            </div>
          </div>
          <div className="content-center justify-center rounded-full bg-[#E1F7FA] p-10 align-middle">
            <Icon
              name={
                registryName === 'model'
                  ? IconNames.Model
                  : IconNames.DatabaseArtifacts
              }
              className="h-24 w-24 text-moon-600 text-teal-600"
            />
          </div>
        </div>

        <div className="flex h-full w-full flex-col items-start gap-12">
          <div
            className="flex w-full items-start gap-10 overflow-auto"
            style={{scrollbarWidth: 'none'}}>
            {!allowAllArtifactTypesInRegistry ? (
              types?.map(type => {
                return (
                  <Tooltip
                    key={type}
                    trigger={
                      <div className="cursor-pointer">
                        <Pill color="moon" label={type} />
                      </div>
                    }
                    content={`Artifact type: ${type}`}
                    position="bottom left"
                  />
                );
              })
            ) : (
              <Pill color="moon" label={'All types'} />
            )}
          </div>
          <div className="flex items-center justify-center gap-2">
            <Icon name="row-height-small" className="h-12 w-12 text-moon-450" />
            <div className="text-xs text-moon-450">
              {`${formatNumber(collectionCount)} ${maybePluralizeWord(
                collectionCount,
                'collection',
                's'
              )}`}
            </div>
          </div>
        </div>
      </div>
    </Tailwind>
  );
};
